import React, {Component} from "react";
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js'
import axios from "axios";
import { getModuleUrl } from "../../moduleConfig";
import { clearAppStoragePreservingTheme, getThemeColor } from "../../theme/branding";
Chart.register(...registerables)

class Dashboard extends Component{

    state = {
        
        labels :[],
        data : []
      }

      componentDidMount(){
        this.refreshToken();
        this.getBooks();
      }

      async refreshToken () {
        try{
            var token = await axios.get('token');
            if(token.status === 200)
            {
                var user = (token.data.data);
                localStorage.setItem("user", JSON.stringify(user));
            }
            else{
                axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
                clearAppStoragePreservingTheme();
                window.location.replace(getModuleUrl("biblio", "login"))
            }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            clearAppStoragePreservingTheme();
            window.location.replace(getModuleUrl("biblio", "login"))
        }
    }

      async getBooks(){
        var bookstat = await axios.get('bookstat');

        if(bookstat.status === 200)
        {
            var labels = [], data = [];
            bookstat.data.map((book) => {
                if(book.borrows.length > 0){
                    labels.push(book.title + " " + book.spot.spot);
                    data.push(book.borrows.length > 0 ? book.borrows.length : 0);
                }
            })

            this.setState({
                labels : labels,
                data : data
            })
        }
      }

    render(){
        const dashboardAccent = getThemeColor();
        const borrowTotal = this.state.data.reduce((total, value) => total + Number(value || 0), 0);
        const leadingIndex = this.state.data.indexOf(Math.max(...this.state.data, 0));
        const leadingBook = leadingIndex >= 0 ? this.state.labels[leadingIndex] : "Aucun emprunt enregistre";
        var data = {
            labels: this.state.labels,
            datasets: [
            {
                label: 'Emprunts',
                backgroundColor: this.state.data.map((_, index) => index === leadingIndex ? dashboardAccent : `${dashboardAccent}55`),
                borderColor: 'transparent',
                borderRadius: 8,
                borderSkipped: false,
                data: this.state.data
            }
            ],
        }
        return(
            <div className="ev-dashboard ev-dashboard--library">
                <div className="library-hero">
                    <div className="ev-dashboard__heading">
                        <span className="ev-dashboard__eyebrow">Le carnet de la bibliothèque</span>
                        <h1 className="ev-dashboard__title">Ce que les lecteurs <em>dévorent</em></h1>
                        <p className="ev-dashboard__subtitle">Une lecture immédiate des ouvrages qui circulent le plus dans l'établissement.</p>
                    </div>
                    <div className="library-hero__stamp">
                        <strong>{borrowTotal}</strong>
                        <span>emprunts<br />observes</span>
                    </div>
                </div>

                <section className="library-feature">
                    <span className="library-feature__index">N. 01</span>
                    <div><span className="library-feature__label">En tete des rayons</span><h2>{leadingBook}</h2></div>
                </section>
                <section className="ev-dashboard__panel library-chart">
                <div className="ev-dashboard__panel-head">
                    <div><span className="ev-dashboard__eyebrow">Palmarès</span><h2>Les ouvrages les plus empruntés</h2></div>
                    <span className="library-chart__count">{data.labels.length} titres</span>
                </div>
                {
                    data.labels.length > 0 && (
                        <Bar
                            data={data}
                            options={{
                            indexAxis: 'y', responsive: true, maintainAspectRatio: false,
                            scales: { x: { beginAtZero: true, grid: { color: `${dashboardAccent}14` } }, y: { grid: { display: false } } },
                            plugins: {
                                title: {
                                display: true,
                                text: "Livres le plus emprentés  "
                                },
                                legend: {
                                display: true,
                                position: "bottom"
                            }
                            }
                            }}
                        />
                    )
                }
                </section>
            </div>
        )
    }
}
export default Dashboard;
